import * as Sentry from '@sentry/nuxt';

export default defineNuxtPlugin(() => {
  const user = useSupabaseUser();
  watch(
    user,
    (u) => {
      Sentry.setUser(u ? { id: u.id, email: u.email ?? undefined } : null);
    },
    { immediate: true },
  );
});
